export default __webpack_public_path__ + "static/media/background-2.25123972.jpg";